import { ActionTypes } from "./types.ts";
import { CartItem } from "../../models/cart-item";

export const addToCart = (item: CartItem) => {
  return {
    type: ActionTypes.ADD_ITEM,
    payload: item,
  };
};

export const removeFromCart = (itemId: string) => {
  return {
    type: ActionTypes.REMOVE_ITEM,
    payload: itemId,
  };
};

export const updateCartItemQuantity = (id: number, quantity: number) => {
  return {
    type: ActionTypes.UPDATE_ITEM_QUANTITY,
    payload: { id, quantity },
  };
};

export const clearCart = () => {
  return {
    type: ActionTypes.CLEAR_CART,
  };
};
